import { Injectable } from '@angular/core';
import { Router, NavigationCancel, NavigationError } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private container: HTMLElement;
  private loader: HTMLElement;
  private labelSpan: HTMLSpanElement;

  private _visible$ = new BehaviorSubject<boolean>(false);
  public readonly visible$ = this._visible$.asObservable();

  constructor(private router: Router) {
    this.container = document.createElement('div');
    this.container.className = 'global-loading-overlay';

    this.loader = document.createElement('cwc-loader');
    this.loader.setAttribute('size', 'large');
    this.loader.classList.add('cwc-modal-spinner'); // always white

    this.labelSpan = document.createElement('span');
    this.labelSpan.setAttribute('slot', 'loading');
    this.loader.appendChild(this.labelSpan);

    this.container.appendChild(this.loader);

    // Hide the overlay & loader if something interrupts the loading process
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.hide();
      }
    });

    // Hide the overlay & loader if the user clicks the browsers back button
    window.addEventListener('popstate', () => this.hide());
  }

  /**
   * Show the overlay & spinner
   * @param label Optional label to display under the spinner
   */
  show(label?: string): void {
    if (label != null) {
      this.labelSpan.textContent = label;
    }
    if (!document?.body?.contains(this.container)) {
      document.body.appendChild(this.container);
      this._visible$.next(true);
    }
  }

  /**
   * Remove overlay & spinner
   */
  hide(): void {
    if (document.body.contains(this.container)) {
      document.body.removeChild(this.container);
      this._visible$.next(false);
    }
  }
}
